module.exports = __webpack_public_path__ + "static/3-86ade28f8fe309b5077e4d1c3c405078.jpg";